import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';

export const UPSALE_QUESTIONS_PANEL_NAME = 'upsaleQuestionsPanel';

export interface UpsaleQuestionsPanelData {
  productUUID: string;
  productName?: string;
}

/**
 * Page produit — side panel d'attache des questions upsale (remplace le
 * dialogue DragDropLists). Même contrat que AddProductPanelService : open()
 * résout une seule fois ; le résultat est la dernière réponse API
 * d'attach/detach/reorder (falsy = aucun changement).
 */
@Injectable({ providedIn: 'root' })
export class UpsaleQuestionsPanelService {
  private _result$: Subject<any | false> | null = null;
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);
  private _data: UpsaleQuestionsPanelData | null = null;

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  open(data: UpsaleQuestionsPanelData): Observable<any | false> {
    if (this._result$) {
      this._result$.complete();
    }
    this._result$ = new Subject<any | false>();
    this._data = data;

    this._isOpen$.next(true);
    setTimeout(() => {
      this._fuseSidebarService.getSidebar(UPSALE_QUESTIONS_PANEL_NAME)?.open();
    });

    return this._result$.asObservable().pipe(take(1));
  }

  getData(): UpsaleQuestionsPanelData | null {
    return this._data;
  }

  emitResult(result: any | false): void {
    this._fuseSidebarService.getSidebar(UPSALE_QUESTIONS_PANEL_NAME)?.close();

    this._result$?.next(result);
    this._result$?.complete();
    this._result$ = null;
    this._data = null;
    this._isOpen$.next(false);
  }
}
